import axios from 'axios'
import { BLOQUEAR_USUARIOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default (idUsuario) => dispach =>
  axios.post(`${URL}/usuarios/${idUsuario}/bloquear-usuario-em-lote`,SLOW_REQUEST_CONFIG)
    .then( response => dispach({
      type: BLOQUEAR_USUARIOS,
      payload: response
    }));